setTimeout(() => {
  const hrefLinks =
    document.querySelectorAll('.otnotice .otnotice-section') &&
    document.querySelectorAll('.otnotice .otnotice-section')[0];
  hrefLinks &&
    hrefLinks.querySelectorAll(' ul li').forEach((li, i) => {
      const anchorTag = li.querySelector('a');
      const sectionTag = document.querySelectorAll('.otnotice-sections section');
      if (anchorTag && anchorTag.hash.charAt(0) === '#') {
        const valueAfterHash = anchorTag.hash.substring(1);
        if (i < sectionTag.length) {
          sectionTag[i + 1].id = valueAfterHash;
        }
      }
    });
}, 3000);